<template>
  <span v-if="visible" class="sf-input-cont sf" :double="doubleWidth">
    <ElInput
      v-model="input"
      class="sf-input"
      :type="type"
      :placeholder="label"
      :clearable="clearable"
      @keyup.enter="submit"
    >
      <template v-if="help || $slots.suffix" #suffix>
        <HelpIcon v-if="help" :help="help" />
        <slot name="suffix" />
      </template>
    </ElInput>
  </span>
</template>

<script lang="ts">
/**
 * ### 文本输入框组件
 */
import { defineComponent } from 'vue';
import { ElInput } from 'element-plus';
import { trim } from 'lodash-es';
import { buildSearchFieldProps, setupSearchField } from '../SearchField';

const ValueCtor = String;

const props = buildSearchFieldProps(ValueCtor, {
  /**
   * ### 输入值是否可清除
   */
  clearable: { type: Boolean, default: true },
  /**
   * ### 组件是否占两格
   */
  double: { type: Boolean },
  /**
   * ### 帮助信息
   */
  help: { type: String }
} as const);

export default defineComponent({
  extends: ElInput,
  inheritAttrs: true,
  props,
  setup(props, ctx) {
    return setupSearchField(
      ValueCtor,
      props,
      ctx,
      () => {
        const doubleWidth = props.double ? '' : undefined;

        return { doubleWidth };
      },
      {
        translate(v: string | undefined) {
          return v && trim(v);
        }
      }
    );
  }
});
</script>

<style lang="scss" scoped>
.sf-input {
  //width: auto;
  height: var(--sf-line-height);

  --el-font-size-base: var(--sf-font-size);
  --el-input-icon-color: #8f959e;

  :deep(.el-input__wrapper) {
    box-shadow: none;
    border-radius: var(--sf-border-radius);
    border: 1px solid var(--sf-border-color);
    height: calc(var(--sf-line-height) - 2px);
    padding: 0 2px;
  }

  :deep(.el-input__wrapper:hover, .el-input__wrapper:focus) {
    border-color: var(--sf-border-hover-color);
  }

  :deep(.el-input__prefix) {
    max-width: var(--sf-prefix-width);
    margin-right: var(--sf-prefix-right-space);
    overflow: hidden;
  }

  :deep(.el-input__inner) {
    height: calc(var(--sf-line-height) - 2px);
    line-height: calc(var(--sf-line-height) - 2px);
    padding: 0 8px;
  }

  //fix erp2
  :deep(.el-input__suffix) {
    align-items: center;
  }
}

.sf-input-cont[double] {
  grid-column-start: span 2;
}
</style>
